import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {BrowseComponent} from "@app/modules/browse/browse.component";
import {PaginationModule} from "@pb-labs/pagination";
import {TextInputModule} from "@pb-labs/text-input";
import {ButtonModule} from "@pb-labs/button";
import {LoaderModule} from "@pb-labs/loader";
import {HighlightModule} from "@app/pipes/highlighter/highlight.module";
import {ScrollbarModule} from "@pb-labs/scrollable-container";
import {ModalModule} from "@pb-labs/modal";
import {IconModule} from "@pb-labs/icon";
import {SettingsComponent} from "@app/modules/browse/components/settings/settings.component";
import {SortableHeaderDirective} from "@app/modules/browse/components/browse-table/sortable.directive";
import {BrowseSidebarComponent} from "@app/modules/browse/components/browse-sidebar/browse-sidebar.component";
import {TopPanelComponent} from "@app/modules/browse/components/top-panel/top-panel.component";
import {UserCornerPopupComponent} from "@app/modules/browse/components/top-panel/components/user-corner-popup/user-corner-popup.component";
import {DeleteVerificationModalComponent} from "@app/modules/browse/components/delete-verification-modal/delete-verification-modal.component";
import {FileUploadModalLayoutComponent} from "@app/modules/browse/components/shared/file-upload-modal/layout/file-upload-modal-layout.component";
import {FileUploadModalComponent} from "@app/modules/browse/components/file-upload-modal/file-upload-modal.component";
import {ForceUploadVerificationModalComponent} from "@app/modules/browse/components/file-upload-modal/components/force-upload-verification-modal/force-upload-verification-modal.component";
import {PublicKeyUploadModalComponent} from "@app/modules/browse/components/public-key-upload-modal/public-key-upload-modal.component";
import {BrowseTableComponent} from "@app/modules/browse/components/browse-table/browse-table.component";
import {DragAndDropFileModule} from "@app/shared/components/drag-and-drop-file/drag-and-drops.module";
import {TextAreaModule} from "@pb-labs/text-area";
import {PopoverModule} from "@pb-labs/popover";
import {NotificationModule} from "@pb-labs/notification";
import {CheckboxButtonModule} from "@pb-labs/checkbox-button";
import {BrowseService} from "@app/modules/browse/services/browse.service";
import {SortableService} from "@app/modules/browse/components/browse-table/sortable.service";
import {DeleteVerificationModalService} from "@app/modules/browse/components/delete-verification-modal/delete-verification-modal.service";
import {FileUploadModalService} from "@app/modules/browse/components/file-upload-modal/file-upload-modal.service";
import {ForceUploadVerificationModalService} from "@app/modules/browse/components/file-upload-modal/components/force-upload-verification-modal/force-upload-verification-modal.service";
import {SFTPConnectionService} from "@app/services/sftp-connection.service";
import {AuthorizationService} from "@app/services/authorization.service";
import {UserSettingsService} from "@app/modules/browse/components/settings/settings.service";
import {FileOperationsService} from "@app/services/file-operations.service";
import {PublicKeyUploadModalService} from "@app/modules/browse/components/public-key-upload-modal/public-key-upload-modal.service";
import {FileUploadModalLayoutService} from "@app/modules/browse/components/shared/file-upload-modal/layout/file-upload-modal-layout.service";
import {ApplicationEnvironmentMessageModule} from "@app/shared/components/application-environment-message/application-environment-message.module";

@NgModule({
  declarations: [
    BrowseComponent,
    SettingsComponent,
    BrowseTableComponent,
    SortableHeaderDirective,
    BrowseSidebarComponent,
    TopPanelComponent,
    UserCornerPopupComponent,
    DeleteVerificationModalComponent,
    FileUploadModalLayoutComponent,
    FileUploadModalComponent,
    ForceUploadVerificationModalComponent,
    PublicKeyUploadModalComponent,
  ],
  imports: [
    CommonModule,
    DragAndDropFileModule,
    PaginationModule,
    TextInputModule,
    ButtonModule,
    HighlightModule,
    LoaderModule,
    ScrollbarModule,
    ModalModule,
    IconModule,
    TextAreaModule,
    PopoverModule,
    NotificationModule,
    CheckboxButtonModule,
    ApplicationEnvironmentMessageModule,
  ],
  providers: [
    BrowseService,
    SortableService,
    DeleteVerificationModalService,
    FileUploadModalService,
    ForceUploadVerificationModalService,
    SFTPConnectionService,
    AuthorizationService,
    UserSettingsService,
    FileOperationsService,
    PublicKeyUploadModalService,
    FileUploadModalLayoutService,
  ],
  exports: [BrowseComponent],
})
export class BrowseModule {}
